import {createActions} from 'redux-actions';
import fetchJson from '../fetchJson';
import handleError from '../handleError';

// CLEAR_STREAM -> for testing only, allows admins to see multiple users streams
const actions = createActions(
	'STREAM_LOADING',
	'STREAM_LOADED',
	'CLEAR_STREAM',
	'AVATARS_LOADED',
	'COMMUNITY_LISTING_MODEL_OPENED',
	'COMMUNITY_LISTING_MODEL_CLOSED',
	'STREAM_PROMOTION_ADD_MODEL_OPENED',
	'STREAM_PROMOTION_ADD_MODEL_CLOSED'
);

const loadStream = userUuid => (dispatch, getState) => {
	// uncomment below when deploying full version
	//const userUuid = getState().session.current.user.uuid;

	dispatch(actions.streamLoading());

	fetchJson(`/api/stream/${userUuid}?offset=${getState().stream.offset}`)
		.then(res => dispatch(actions.streamLoaded(res)))
		.catch(err => handleError(dispatch)(err));
};

const loadCommunityAvatars = communityUuid => dispatch => {
	fetchJson(`/api/community/${communityUuid}/members/avatars`)
		.then(res => dispatch(actions.avatarsLoaded({communityUuid, res})))
		.catch(err => handleError(dispatch(err)));
};

export default {
	loadStream,
	loadCommunityAvatars,
	...actions
};



// WEBPACK FOOTER //
// ./src/stream/stream.actions.js